




































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Empty } from "vant";
import { getBrowser } from "@/utils/browser";

@Component({
  name: 'AssessmentResult',
  components: {
    [Button.name]: Button,
    [Empty.name]: Empty
  }
})
export default class AssessmentResult extends Vue {
  isAPP = getBrowser().isApp;
  resultData = null;
  popUpVisible = false;
  textContent: any = [];
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getRiskResultData();
    this.textContent = this.$t("assessment.result.textContent");
  }

  activated() {
    this.resultData = null;
    this.popUpVisible = false;
    this.getRiskResultData();
  }

  getRiskResultData() {
    (this as any).$apis
      .getRiskAssessment({})
      .then(res => {
        this.requestFail = false;
        if (JSON.stringify(res) === "{}") {
          this.$router.replace({ name: "RiskQuestionnaire" });
        } else {
          this.resultData = res;
        }
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  jumpToAssessment() {
    this.$router.replace({ name: "RiskQuestionnaire" });
  }

  handleButtonClick() {
    this.popUpVisible = true;
  }

  handleButtonClick2() {
    this.$router.push({ name: "CustomerAgreement1" });
    // this.$router.push({ name: "RiskDisclosure" });
  }

  handleBtnClick() {
    this.popUpVisible = false;
  }
}
